import React, { useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CustomButton from "../../shared/CustomButton";
import { sendTestEmail } from "../state/actions";
import { useDispatch } from "react-redux";

const StmpConfig = ({
  formik,
  setTouched,
  success,
  error,
  sendingTestEmail,
}) => {
  const dispatch = useDispatch();
  const [testEmail, setTestEmail] = useState("");
  const [testEmailError, setTestEmailError] = useState(null);

  const handleChangeTestEmail = (e) => {
    setTestEmail(e.target.value);
  };

  const handleSendTestEmail = (e) => {
    if (
      !String(testEmail).match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      setTestEmailError("Enter a Valid Email Address");
    } else {
      setTestEmailError(null);
      dispatch(sendTestEmail({ email: testEmail }, success, error));
    }
  };

  const handleChange = (e) => {
    setTouched(true);
    formik.handleChange(e);
  };
  return (
    <Grid
      container
      direction="column"
      rowSpacing="16px"
      justifyContent="flex-start"
      sx={{
        background: "#ffffff",
        borderRadius: "6px",
        border: "1px solid #E7E9EF",
        padding: "20px 30px 36px 30px",
        marginTop: "2px",
      }}
    >
      <Grid item>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1.125rem",
            fontWeight: 550,
            marginBottom: "8px",
          }}
        >
          SMTP Configurations
        </Typography>
      </Grid>

      <Grid item>
        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Email
          </Typography>
          <TextField
            name="smtpEmail"
            value={formik.values.smtpEmail}
            onChange={handleChange}
            error={formik.touched.smtpEmail && Boolean(formik.errors.smtpEmail)}
            helperText={formik.touched.smtpEmail && formik.errors.smtpEmail}
            sx={{
              width: "360px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.smtpEmail && { marginBottom: "10px" }),
            }}
          />
        </Box>
      </Grid>
      <Grid item>
        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Username
          </Typography>
          <TextField
            name="smtpUsername"
            value={formik.values.smtpUsername}
            onChange={handleChange}
            error={
              formik.touched.smtpUsername && Boolean(formik.errors.smtpUsername)
            }
            helperText={
              formik.touched.smtpUsername && formik.errors.smtpUsername
            }
            sx={{
              width: "360px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.smtpUsername && { marginBottom: "10px" }),
            }}
          />
          <Typography
            sx={{
              color: "#8792AB",
              fontSize: "12px",
              lineHeight: "16px",
              marginTop: "5px",
              ...(formik.errors.smtpUsername && { marginTop: "10px" }),
            }}
          >
            If the SMTP server requires authentication, you need to specify the
            user.
          </Typography>
        </Box>
      </Grid>

      <Grid item>
        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Password
          </Typography>
          <TextField
            name="smtpPassword"
            value={formik.values.smtpPassword}
            onChange={handleChange}
            error={
              formik.touched.smtpPassword && Boolean(formik.errors.smtpPassword)
            }
            helperText={
              formik.touched.smtpPassword && formik.errors.smtpPassword
            }
            sx={{
              width: "360px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.smtpUsername && { marginBottom: "10px" }),
            }}
            type="password"
          />
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "flex-start", gap: "16px" }}
      >
        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Server Name
          </Typography>
          <TextField
            name="smtpIp"
            value={formik.values.smtpIp}
            onChange={handleChange}
            error={formik.touched.smtpIp && Boolean(formik.errors.smtpIp)}
            helperText={formik.touched.smtpIp && formik.errors.smtpIp}
            sx={{
              width: "360px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.smtpUsername && { marginBottom: "10px" }),
            }}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Port
          </Typography>
          <TextField
            name="smtpPort"
            value={formik.values.smtpPort}
            onChange={handleChange}
            error={formik.touched.smtpPort && Boolean(formik.errors.smtpPort)}
            helperText={formik.touched.smtpPort && formik.errors.smtpPort}
            sx={{
              width: "180px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.smtpUsername && { marginBottom: "10px" }),
            }}
          />
        </Box>
      </Grid>
      <Grid item>
        <FormControlLabel
          name="smtpAutoTLS"
          value={formik.values.smtpAutoTLS}
          onChange={handleChange}
          control={<Checkbox />}
          label="Auto TLS"
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          gap: "16px",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Recipient for testing
          </Typography>
          <TextField
            name="testEmail"
            value={testEmail}
            onChange={handleChangeTestEmail}
            error={testEmailError}
            helperText={testEmailError}
            sx={{
              width: "360px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              marginRight: "20px",
            }}
          />
          <CustomButton
            type="secondary"
            text="Send Test Email"
            action={handleSendTestEmail}
            processing={sendingTestEmail}
            disabled={sendingTestEmail}
          >
            Send Test Email
          </CustomButton>
        </Box>
      </Grid>
    </Grid>
  );
};

export default StmpConfig;
